// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__12gdn","buttons":"PendingPaymentAlert_buttons__1_Fpc"};